export interface EmailEditorLink {
  label: string
  href: string
  text: string
}

export interface EmailEditorAsset {
  label: string
  url: string
  thumbnail: string
}

export function normaliseEmailEditorLinks (links: unknown): EmailEditorLink[] {
  if (!Array.isArray(links)) return []

  return links.flatMap((link: any) => {
    if (!link || typeof link !== 'object') return []

    const href = link.placeholder ?? link.href ?? link.url ?? link.value
    if (typeof href !== 'string' || !href.length) return []

    const label = link.name ?? link.label ?? link.text ?? href
    const text = link.text ?? link.name ?? link.label ?? ''

    return [{
      label: String(label),
      href,
      text: String(text),
    }]
  })
}

export function normaliseEmailEditorAssets (assets: unknown): EmailEditorAsset[] {
  if (!Array.isArray(assets)) return []

  return assets.flatMap((asset: any, index) => {
    if (!asset || typeof asset !== 'object') return []

    const url = asset.url ?? asset.file?.url ?? asset.imageUrls?.large
    if (typeof url !== 'string' || !url.length) return []

    const label = asset.alt ?? asset.name ?? asset.caption ?? asset.file?.name ?? `Image ${index + 1}`

    const thumbnail = asset.thumbnail ?? asset.thumb ?? asset.imageUrls?.square ?? asset.imageUrls?.medium ?? url

    return [{ label: String(label), url, thumbnail: String(thumbnail) }]
  })
}

export function isSafeEmailLink (href: string): boolean {
  const value = href.trim()
  if (!value) return false

  if (/^\{\{[\s\S]+\}\}$/.test(value)) return true
  if (/^(https?:|mailto:|tel:)/i.test(value)) return true
  if (/^(\/|#)/.test(value)) return true

  return !/^[a-z][a-z\d+.-]*:/i.test(value)
}
